import React from 'react';
import { FormattedMessage as Trans } from 'react-intl';

import { usePreferences } from '../hooks/usePreferences';
import { usePaths } from '../hooks/usePaths';

import FormRow from './FormRow';

export default function PreferencesStep0() {
  const { getHomepagePath } = usePaths();
  const {
    allOptIn,
    marketInsights,
    productReleases,
    smarterShipping,
    convelioInsider,
    directContacts,
    isLoading,
    save,
    handleToggle,
    handleToggleAll
  } = usePreferences();

  const buttons = [
    {
      page: getHomepagePath(),
      version: 'tertiary-text',
      label: <Trans id="buttonLabelCancel" />
    },
    {
      onClick: save,
      isDisabled: isLoading,
      version: 'primary',
      label: <Trans id="buttonLabelSave" />
    }
  ];

  return (
    <form noValidate className="form" data-module="form">
      <FormRow
        title={<Trans id="preferencesSwitchAllTitle" />}
        description={<Trans id="preferencesSwitchAllDescription" />}
        name="optInStatus"
        value={allOptIn}
        handleChange={handleToggleAll}
      />

      <FormRow
        title={<Trans id="preferencesMarketInsightsTitle" />}
        description={<Trans id="preferencesMarketInsightsDescription" />}
        example={<Trans id="preferencesMarketInsightsExamples" />}
        name="marketInsights"
        value={marketInsights}
        handleChange={() => handleToggle('marketInsights')}
      />
      <FormRow
        title={<Trans id="preferencesSmarterShippingTitle" />}
        description={<Trans id="preferencesSmarterShippingDescription" />}
        example={<Trans id="preferencesSmarterShippingExamples" />}
        name="smarterShipping"
        value={smarterShipping}
        handleChange={() => handleToggle('smarterShipping')}
      />
      <FormRow
        title={<Trans id="preferencesProductReleasesTitle" />}
        description={<Trans id="preferencesProductReleasesDescription" />}
        example={<Trans id="preferencesProductReleasesExamples" />}
        name="productReleases"
        value={productReleases}
        handleChange={() => handleToggle('productReleases')}
      />
      <FormRow
        title={<Trans id="preferencesConvelioInsiderTitle" />}
        description={<Trans id="preferencesConvelioInsiderDescription" />}
        example={<Trans id="preferencesConvelioInsiderExamples" />}
        name="convelioInsider"
        value={convelioInsider}
        handleChange={() => handleToggle('convelioInsider')}
      />
      <FormRow
        title={<Trans id="preferencesDirectContactWithConvelioTeamTitle" />}
        name="directContacts"
        value={directContacts}
        handleChange={() => handleToggle('directContacts')}
      />
      <FormRow buttons={buttons} />
    </form>
  );
}
